import React from 'react';
import FullOutageImage from './FullOutageImage.png';

export const FullOutageIcon = () => {
    return <img src={FullOutageImage} />;
}